import React from 'react'
import styles from './styles.module.css'
import SimpleBlockContent from '../../../SimpleBlockContent'
import Text from '../../../Text'
import { $textPrimary, $textTertiary } from '../../../../styles/colors/semantics'

// Placeholder icon
const PlaceholderIcon = () => (
  <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1">
    <rect x="8" y="16" width="8" height="24" rx="1" />
    <rect x="20" y="8" width="8" height="32" rx="1" />
    <rect x="32" y="20" width="8" height="20" rx="1" />
  </svg>
)

function GetFasterWhyUs({
  eyebrow,
  title,
  features = [],
  centerImage,
  rightImage
}) {
  // Left column: first 3 features (with icons)
  const leftFeatures = features.slice(0, 3)
  // Center text card: feature at index 3
  const centerFeature = features[3]
  // Right text card: feature at index 4
  const rightFeature = features[4]

  // task #67: centerImage/rightImage are now ResolvedImage descriptors; use .src
  const centerImageSrc = centerImage?.src || null
  const rightImageSrc = rightImage?.src || null

  return (
    <div className={styles.wrapper}>
      <div className={styles.contentWrapper}>
        <div className={styles.header}>
          {eyebrow && <Text type="heading-8" color={$textTertiary.dark}>{eyebrow}</Text>}
          {title && (
            <h2 className={styles.title}>
              <SimpleBlockContent blocks={title} />
            </h2>
          )}
        </div>

        <div className={styles.bentoGrid}>
          {/* Left column - 3 feature cards with icons */}
          <div className={styles.leftColumn}>
            {leftFeatures.map((feature, index) => (
              <div className={styles.featureCard} key={`left-${index}`}>
                <div className={styles.featureCardHeader}>
                  <div className={styles.iconWrapper}>
                    <PlaceholderIcon />
                  </div>
                  <h3 className={styles.cardTitle}><Text type="heading-8" color={$textPrimary.dark}>{feature.title}</Text></h3>
                </div>
                <div className={styles.cardDescription}><Text type="small" color={$textTertiary.dark}>{feature.description}</Text></div>
              </div>
            ))}
          </div>

          {/* Center column - Image + text in one card */}
          <div className={styles.centerColumn}>
            <div className={styles.centerCard}>
              <div className={centerImageSrc ? styles.centerCardImageArea : `${styles.centerCardImageArea} ${styles.centerCardImageAreaEmpty}`}>
                {/* eslint-disable-next-line local-rules/prefer-img-component -- Phase 3.5 (#89) faithful CSS-Modules port of the former styled.img; box reserved via aspect-ratio (styles.centerCardImage / inline aspectRatio), no CLS. */}
                {centerImageSrc && <img className={styles.centerCardImage} src={centerImageSrc} style={{ aspectRatio: centerImage?.aspectRatio }} alt="" />}
              </div>
              {centerFeature && (
                <div className={styles.centerCardContent}>
                  <h3 className={styles.cardTitle}><Text type="heading-5" color={$textPrimary.dark}>{centerFeature.title}</Text></h3>
                  <div className={styles.cardDescription}><Text type="small" color={$textTertiary.dark}>{centerFeature.description}</Text></div>
                </div>
              )}
            </div>
          </div>

          {/* Right column - Image + text in one card */}
          <div className={styles.rightColumn}>
            <div className={styles.rightCard}>
              <div className={rightImageSrc ? styles.rightCardImageArea : `${styles.rightCardImageArea} ${styles.rightCardImageAreaEmpty}`}>
                {/* eslint-disable-next-line local-rules/prefer-img-component -- Phase 3.5 (#89) faithful CSS-Modules port of the former styled.img; box reserved via aspect-ratio (styles.rightCardImage / inline aspectRatio), no CLS. */}
                {rightImageSrc && <img className={styles.rightCardImage} src={rightImageSrc} style={{ aspectRatio: rightImage?.aspectRatio }} alt="" />}
              </div>
              {rightFeature && (
                <div className={styles.rightCardContent}>
                  <h3 className={styles.cardTitle}><Text type="heading-5" color={$textPrimary.dark}>{rightFeature.title}</Text></h3>
                  <div className={styles.cardDescription}><Text type="small" color={$textTertiary.dark}>{rightFeature.description}</Text></div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default GetFasterWhyUs
